<template>
  <div class="filter-container flex-row">
    <div class="filter-op">
      <menu-wrapper>
        <template #menu-button="{toggleMenu}">
          <button tabindex="-1" class="btn-filter-operator" @click="toggleMenu">
            <div :class="['icon24', nativeFilterIconClass]" />
          </button>
        </template>
        <template #menu-content>
          <template v-for="(item, i) in filterOperators" :key="i">
            <menu-item
              class="filter-operator-item"
              :class="item.enumValue === operatorValue ? 'active' : ''"
              :icon="['icon24', item.icon]"
              @menu-item-click="filterOperatorItemClick(item)"
            >
              {{ item?.enumText }}
            </menu-item>
          </template>
        </template>
      </menu-wrapper>
    </div>
    <div class="filter-value flex">
      <ms-input
        ref="filterInput"
        v-model="filterValue"
        :read-only="operatorValueReadonly"
        class="w-full ms-input-filter-value"
        :has-border="false"
        @filterGrid="filterHeaderHandle({operator: operatorValue, value: filterValue})"
        :filterSeachGrid="col.filterSeachGrid"
        @keyup.enter="filterHeaderHandle({operator: operatorValue, value: filterValue})"
        @keydown.stop=""
      />
    </div>
  </div>
</template>
<script>
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import {defineComponent, getCurrentInstance} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
export default defineComponent({
  name: 'MsThOptionText',
  components: {
    MenuItem,
    MenuWrapper,
  },
  extends: msThOptionBase,
  props: {},
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    // Khai báo data variable
    const {
      nativeFilterIconClass,
      operatorValue,
      operatorValueReadonly,
      filterValue,
      filterInput,
      filterOperators,
      filterHeaderHandle,
      filterOperatorItemClick,
      removeFilter,
      updateFilterValue,
    } = setup(props, {
      emit,
    });
    // Method
    // Hooks
    const keyupHandler = e => {
      if (e.keyCode === proxy.$ms.constant.KeyCode.Enter) {
        filterHeaderHandle({operator: operatorValue, value: filterValue});
      }
    };
    return {
      nativeFilterIconClass,
      filterInput,
      filterValue,
      operatorValue,
      operatorValueReadonly,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandle,
      removeFilter,
      keyupHandler,
      updateFilterValue,
    };
  },
});
</script>
